import request from "./request";

export const http = {
  //获取核心故障子项
  getCoreFaultOption(params) {
    return request({
      method: "GET",
      url: "/platform/pc/coreFailure/getCoreFaultOption",
      params: params,
    });
  },
  //编辑添加核心故障项
  saveCoreFaultOption(params) {
    return request({
      method: "POST",
      url: "/platform/pc/coreFailure/saveCoreFaultOption",
      data: params,
    });
  },
  //修改核心故障子项排序
  updateCoreFaultOptionSort(params) {
    return request({
      method: "GET",
      url: "/platform/pc/coreFailure/updateCoreFaultOptionSort",
      params: params,
    });
  },
  //是否启用核心故障子项
  updateCoreFaultOptionIsEnable(params) {
    return request({
      method: "GET",
      url: "/platform/pc/coreFailure/updateCoreFaultOptionIsEnable",
      params: params,
    });
  },
  //删除核心故障项
  removeCoreFaultOptionById(params) {
    return request({
      method: "GET",
      url: "/platform/pc/coreFailure/removeCoreFaultOptionById",
      params: params,
    });
  },
  //设置启用配置
  setCoreFaultEnableConfig(params) {
    return request({
      method: "POST",
      url: "/platform/pc/coreFailure/setCoreFaultEnableConfig",
      data: params,
    });
  },
  //九讯云绑定信息
  jxyBindInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/company/jxy-bind-info",
      params: params,
    });
  },
  //九讯云解绑
  jxyUnbind(params) {
    return request({
      method: "POST",
      url: "/platform/pc/company/unbind-jxy",
      data: params,
    });
  },
  //绑定九讯云
  jxyBind(params) {
    return request({
      method: "POST",
      url: "/platform/pc/company/bind-jxy",
      data: params,
    });
  },
  //绑定外观功能
    bindFinenessTemplateFace(params) {
    return request({
      method: "POST",
      url: "/platform/pc/coreFailure/bindFinenessTemplateFace",
      data: params,
    });
  },
  //取消绑定
    unBindFinenessTemplateFace(params) {
    return request({
      method: "GET",
      url: "/platform/pc/coreFailure/unBindFinenessTemplateFace",
      params: params,
    });
  },
  //查询故障项
  getCoreFaultOptionFailure(params) {
    return request({
      method: "GET",
      url: "/platform/pc/coreFailure/getCoreFaultOptionFailure",
      params: params,
    });
  },
    //添加故障项
    addCoreFaultOptionFailure(params) {
    return request({
      method: "POST",
      url: "/platform/pc/coreFailure/addCoreFaultOptionFailure",
      data: params,
    });
  },
      //添加故障项
    removeCoreFaultOptionFailure(params) {
    return request({
      method: "POST",
      url: "/platform/pc/coreFailure/removeCoreFaultOptionFailure",
      data: params,
    });
  },
};
